import { useAppSelector } from 'hooks/redux';
import type { List } from 'immutable';
import React from 'react';

import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';

import type { TaxFormType } from 'app-components/flux/categories/categoriesTypes';
import { useField } from 'app-components/flux/categories/categoryFormHooks';
import { taxFormsSelectors } from 'app-components/flux/tax-forms';

import useStyles from './styles';

const TaxFormPersonal = () => {
  const { classes } = useStyles();

  const { value: taxForm, onChange, error, helperText } = useField('taxForm');
  const taxForms: List<TaxFormType> = useAppSelector(taxFormsSelectors.getTaxForms);

  return (
    <TextField
      variant='filled'
      label='Tax Form'
      name='taxForm'
      value={taxForm || ''}
      className={classes.dropDown}
      select
      onChange={onChange}
      id='tax-form-dropdown'
      error={error}
      helperText={helperText}
      InputLabelProps={{
        classes: {
          root: classes.inputLabel,
        },
      }}
    >
      {taxForms.map((form) => (
        <MenuItem value={form.id} key={form.id}>
          <Tooltip title={form.description} placement='right'>
            <span>{form.name}</span>
          </Tooltip>
        </MenuItem>
      ))}
    </TextField>
  );
};

export default TaxFormPersonal;
